module.exports = __webpack_public_path__ + "img/prodolz.7ab2b5e3.png";